import { render, staticRenderFns } from "./BarChartDashboard.vue?vue&type=template&id=17e68ebc"
import script from "./BarChartDashboard.vue?vue&type=script&lang=js"
export * from "./BarChartDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports